module.exports = __webpack_public_path__ + "img/DataHub.f36c62ca.png";